module.exports = __webpack_public_path__ + "img/5.63b6c4cb.png";